import React, { useState, useEffect, useCallback } from "react";
import {
  Drawer,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Divider,
  Grid
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import axios from "axios";
import InitiativeDetails from "./InitiativeDetails";
import Tooltip from "@mui/material/Tooltip";
// Added by Gauri to get current stage details on 08 Apr 2025
import GetInitiativeStageDetails from "../../../hooks/GetInitiativeStageDetails/GetInitiativeStageDetails";
import AxiosInstance1 from "app/hooks/AxiosInstance/AxiosInstance1";

const PrioritizationCheckList = ({
  prioritizationCheckList,
  open,
  setOpen,
  setRefresh1,
  refresh,
  // stageDetails
}) => {
  const [selectedCheckList, setSelectedCheckList] = useState(null); // Store selected checklist data
  {
    /* Added selectedCheckListResponseId and priorChecklistID by Gauri on 08 Feb 2025 */
  }

  const [selectedCheckListResponseId, setSelectedCheckListResponseId] = useState(null); // Store selected checklist data
  const [priorChecklistID, setPriorChecklistID] = useState(null); // Store selected checklist data
  const accessToken = sessionStorage.getItem("access_token");
  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const [checkListID1, setCheckListID1] = useState("");
  // Added by Gauri to get current stage details on 08 Apr 2025
  const [stageDetails, setStageDetails] = useState(null);
  // Added by Gauri to get ideaID1 value on 09 Apr 2025
  const [ideaID1, setIdeaID1] = useState(null);

  // Added by Gauri to pass selectedRespondedBY on 27 Mar 2025
  const [selectedRespondedBY, setSelectedRespondedBY] = useState(null);
  const [selectedStageName, setSelectedStageName] = useState(null);

  // Added stageID by Gauri on 18 Mar 2025
  const [stageID, setStageID] = useState(null);
  var checkListID;
  const employeeId = userdata?.employeeId;
  // var ideaID1;
  // Function to close the drawer
  const handleClose = () => {
    setRefresh1(!refresh);
    setOpen(false);
  };

  // Function to handle selecting a checklist and making the API call
  // Passed approverID by Gauri on 25 Apr 2025
  const handleCheckListSelection = (checklistID, revisionID, ideaID, stageID, respondedBY, stageName, approverID) => {
    // console.log("Clicked Row Data:", { checkListID, revisionID, ideaID, stageID, respondedBY, stageName, approverID });

    // if (!respondedBY) {
    //     console.error("Error: respondedBY is undefined for this row.");
    // }

    setSelectedRespondedBY(respondedBY || ""); 
    setSelectedStageName(stageName || ""); 
    // console.log("selectedRespondedBY handleCheckListSelection", selectedRespondedBY);

    // Passed approverID by Gauri on 25 Apr 2025
    // const apiUrl = `${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/InitiativeDetail/GetCheckListResponse?checklistID=${checklistID}&RevisionID=${revisionID}&IdeaID=${ideaID}&UserID=${employeeId}&StageID=${stageID}`;
    const apiUrl = `/api/InitiativeDetail/GetCheckListResponse?checklistID=${checklistID}&RevisionID=${revisionID}&IdeaID=${ideaID}&UserID=${approverID}&StageID=${stageID}`;

    AxiosInstance1
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${accessToken}` // Pass the token in the header
        }
      })
      .then((response) => {
        const responseData = response?.data?.data;
        setSelectedCheckList(response?.data?.data); // Handle the response, store the result in state
        // console.log("Checklist API response:", response?.data?.data);
        {
          /* Added checkListResponsesID to selectedCheckListResponseId by Gauri on 08 Feb 2025 */
        }
        // setSelectedCheckListResponseId(response?.data?.data?.listInitiativeChecklistResponsesEntity?.[0]?.checkListResponsesID)
        const checkListResponsesID =
          responseData?.listInitiativeChecklistResponsesEntity?.[0]?.checkListResponsesID || null;
        setSelectedCheckListResponseId(checkListResponsesID);

        // Added by Gauri to extract `stageID` from response on 18 Mar 2025
        const extractedStageID = responseData?.listInitiativeChecklistResponsesEntity?.[0]?.stageID || stageID;
        setStageID(extractedStageID); // Store stageID in state

        // Extract checklistID from the response if it exists
        const returnedChecklistID = responseData?.checklistID || checklistID; // Fallback to input ID
        // console.log("Extracted Checklist ID:", returnedChecklistID);
        setPriorChecklistID(returnedChecklistID);
      })
      .catch((error) => {
        console.error("Error fetching checklist data:", error);
      });
  };
  // console.log("priorChecklistID priorChecklistID", priorChecklistID);

  // Handle default selection of the first item when the component mounts or data is updated
  // useEffect(() => {
  //   if (prioritizationCheckList?.data?.listInitiativePrioritizationChecklistEntity?.length > 0) {
  //     const firstItem = prioritizationCheckList.data.listInitiativePrioritizationChecklistEntity[0];
  //     // Commented and Added by Gauri to get ideaID1 value on 09 Apr 2025
  //     // ideaID1 = firstItem.ideaID;
  //     setIdeaID1(firstItem.ideaID);
  //     setCheckListID1(firstItem.checkListID);
  //     checkListID = firstItem.checkListID;
  //     handleCheckListSelection(
  //       firstItem.checkListID,
  //       firstItem.revisionID,
  //       firstItem.ideaID,
  //       firstItem.stageID,
  //       firstItem.respondedBY,
  //       firstItem.stageName,
  //       firstItem.approverID
  //     );
  //   }
  // }, [prioritizationCheckList, refresh]); // Only run when prioritizationCheckList changes

  // Added by Gauri to show data of recently saved checklist on 02 May 2025
  useEffect(() => {
    const checklistItems = prioritizationCheckList?.data?.listInitiativePrioritizationChecklistEntity;
    if (checklistItems?.length > 0) {
      const existingSelected = checklistItems.find(item => item.checkListID === checkListID1);
      const fallbackItem = checklistItems[0];
  
      const targetItem = existingSelected || fallbackItem;
  
      setIdeaID1(targetItem.ideaID);
      setCheckListID1(targetItem.checkListID);
      checkListID = targetItem.checkListID;
  
      handleCheckListSelection(
        targetItem.checkListID,
        targetItem.revisionID,
        targetItem.ideaID,
        targetItem.stageID,
        targetItem.respondedBY,
        targetItem.stageName,
        targetItem.approverID
      );
    }
  }, [prioritizationCheckList, refresh]);  

  // useEffect(() => {
  //   const checklistItems = prioritizationCheckList?.data?.listInitiativePrioritizationChecklistEntity;
  
  //   if (checklistItems?.length > 0) {
  //     // Access the last item in the original order
  //     const lastItem = checklistItems[checklistItems.length - 1]; // Original last item
  
  //     // If you prefer to work with reversed items, you can also do this:
  //     // const lastItem = [...checklistItems].reverse()[0]; 
  
  //     // Save last item's values
  //     setIdeaID1(lastItem.ideaID);
  //     setCheckListID1(lastItem.checkListID);
  //     checkListID = lastItem.checkListID;
      
  //     // Passed approverID by Gauri on 25 Apr 2025
  //     handleCheckListSelection(
  //       lastItem.checkListID,
  //       lastItem.revisionID,
  //       lastItem.ideaID,
  //       lastItem.stageID,
  //       lastItem.respondedBY,
  //       lastItem.stageName,
  //       lastItem.approverID
  //     );
  //   }
  // }, [prioritizationCheckList, refresh]); // Only run when prioritizationCheckList changes

  // Fetch checkListID from prioritizationCheckList by Gauri on 08 Feb 2025
  // useEffect(() => {
  //   if (prioritizationCheckList?.data?.listInitiativePrioritizationChecklistEntity?.length > 0) {
  //     const checklistID = prioritizationCheckList?.data?.listInitiativePrioritizationChecklistEntity[0]?.checkListID;
  //     setPriorChecklistID(checklistID);
  //   }
  // }, [prioritizationCheckList, refresh]);

  // console.log("prioritizationCheckList?.data?.listInitiativeChecklistCategoryEntity", priorChecklistID)

  // const renderPercentageBar = (value) => {
  //   const percentage = Math.max(0, Math.min(100, value));

  //   // Set the background color conditionally
  //   const barColor = percentage < 50 ? "#F55D30" : "#03BA28"; // Color changes if less than 50%

  //   return (
  //     <div
  //       style={{
  //         width: "100%",
  //         backgroundColor: "lightgrey",
  //         borderRadius: "4px",
  //         height: "12px", // Reduced height
  //         display: "flex",
  //         position: "relative"
  //       }}
  //     >
  //       <div
  //         style={{
  //           width: `${percentage}%`,
  //           backgroundColor: barColor, // Use the conditional color
  //           height: "100%",
  //           borderRadius: "4px 0 0 4px",
  //           display: "flex",
  //           justifyContent: "center",
  //           alignItems: "center",
  //           color: "black",
  //           fontWeight: "bold",
  //           fontSize: "8px" // Adjusted font size to fit better in reduced height
  //         }}
  //       >
  //         {percentage}%
  //       </div>
  //       <div
  //         style={{
  //           width: `${100 - percentage}%`,
  //           backgroundColor: "grey",
  //           height: "100%",
  //           borderRadius: "0 4px 4px 0"
  //         }}
  //       />
  //     </div>
  //   );
  // };

  // Added by Gauri to update renderPercentageBar color for negative values on 14 Apr 2025
  const renderPercentageBar = useCallback((value) => {
    const isNegative = value < 0;
    const absValue = Math.abs(value);
    const clampedValue = Math.min(100, absValue);

    // const barColor = isNegative
    //   ? "#d72121" // red for negative
    //   : clampedValue < 50
    //     ? "#F55D30" // red if < 50
    //     : "#03BA28"; // green
    
    // Modified by Gauri to update renderPercentageBar color for <50% values on 12 June 2025
    const barColor = isNegative
      ? "#d72121" // red for negative
      : "#03BA28"; // green

    return (
      <div
        style={{
          width: "100%",
          backgroundColor: "lightgrey",
          borderRadius: "4px",
          height: "12px",
          display: "flex",
          position: "relative",
        }}
      >
        <div
          style={{
            width: `${clampedValue}%`,
            backgroundColor: barColor,
            height: "100%",
            borderRadius: Math.abs(value) == 100 ? "4px" : "4px 0 0 4px",
            display: "flex",
            justifyContent: value == 0 || value == null ? 'end' : 'center',
            alignItems: "center",
            color: "black",
            fontWeight: "bold",
            fontSize: "8px",
          }}
        >
          {value}%
        </div>
        <div
          style={{
            width: `${100 - clampedValue}%`,
            backgroundColor: "grey",
            height: "100%",
            borderRadius: value == 0 || value == null ? "4px" : "0 4px 4px 0",
          }}
        />
      </div>
    );
  }, []);

  // Added by Gauri to get current stage details on 08 Apr 2025
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await GetInitiativeStageDetails(ideaID1);
        // console.log("API result full:", result);
  
        const stageApprovalList = result?.data?.initiativeStageDetailsEntity?.[0]?.initiativeStageApprovalDetailsEntity || [];
  
        // console.table(stageApprovalList);
  
        const currentStage = stageApprovalList.find(
          stage => Number(stage.isCurrentStage) === 1
        );
  
        // console.log("Extracted currentStage:", currentStage);
  
        setStageDetails(currentStage);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    if (ideaID1) {
      console.log("ideaID1 in useEffect:", ideaID1);
      fetchData();
    }
  }, [ideaID1]);
  
  useEffect(() => {
    if (stageDetails) {
      // console.log("stageDetails in useEffect:", stageDetails);
    }
  }, [stageDetails]);  

  const validItems = prioritizationCheckList?.data?.listInitiativePrioritizationChecklistEntity?.filter(
    (item) => item?.checkListName
  );  

  // const categoryItems = prioritizationCheckList?.data?.listInitiativeChecklistCategoryEntity?.filter(
  //   (item) => item?.checkListName
  // );  

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      sx={{ width: "90vw" }}
    >
      <div style={{ width: "90vw", padding: 20 }}>
        <div style={{ backgroundColor: "#f5f5f5", borderRadius: "8px" }}>
          <IconButton
            onClick={handleClose}
            style={{
              position: "absolute",
              top: 30,
              right: 30,
            }}
          >
            <Tooltip title="Close">
              <CloseIcon />
            </Tooltip>
          </IconButton>

          <div style={{ marginBottom: "16px", padding: "8px" }}>
            <Typography variant="h6" sx={{ color: "#333" }}>
              Prioritization Checklist
            </Typography>
          </div>
        </div>

        {/* Prioritization CheckList and Checklist Categories Section */}
        <Grid container spacing={2}>
          {/* Prioritization CheckList Table */}
          {/* Updated column width by Gauri on 02 May 2025 */}
          <Grid item xs={12} md={8}>
            <Typography sx={{ color: "#333" }}>
              Prioritization Checklist
            </Typography>

            <TableContainer
              sx={{ border: "1px solid #ccc", borderRadius: "8px" }}
            >
              <Table aria-label="Prioritization Checklist Table">
                <TableHead sx={{ backgroundColor: "#f1f1f1" }}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold", width: "25%", padding: "12px" }}
                    >
                      Responded By
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", width: "20%", padding: "12px" }}
                    >
                      Priority Checklist
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", width: "40%", padding: "12px" }}
                    >
                      Priority Rating
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", width: "15%", padding: "12px" }}
                    >
                      Stage
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/*  {prioritizationCheckList?.data?.listInitiativePrioritizationChecklistEntity
                      ?.length > 0 ? (
                      prioritizationCheckList.data.listInitiativePrioritizationChecklistEntity.map( */}

                  {/* Added by Gauri to get current checklist details on 29 Apr 2025 */}
                  {validItems?.length > 0 ? (
                    // [...validItems].reverse().map(
                    [...validItems].map((item, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          backgroundColor:
                            index % 2 === 0 ? "#f9f9f9" : "transparent",
                        }}
                        // Passed approverID by Gauri on 25 Apr 2025
                        onClick={() => {
                          setCheckListID1(item.checkListID);
                          checkListID = item.checkListID;
                          handleCheckListSelection(
                            item.checkListID,
                            item.revisionID,
                            item.ideaID,
                            item.stageID,
                            item.respondedBY,
                            item.stageName,
                            item.approverID
                          );
                        }}
                      >
                        <TableCell sx={{ padding: "12px" }}>
                          {item.respondedBY}
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "12px",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          {item.checkListName}
                        </TableCell>
                        <TableCell sx={{ padding: "12px" }}>
                          {renderPercentageBar(item.weightage)}
                        </TableCell>
                        <TableCell sx={{ padding: "12px" }}>
                          {item.stageName}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan="4"
                        sx={{ textAlign: "center", padding: "12px" }}
                      >
                        {/* No Prioritization Checklist Available */}
                        No item to show
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          {/* Checklist Categories Table */}
          {/* Updated column width by Gauri on 02 May 2025 */}
          <Grid item xs={12} md={4}>
            <Typography sx={{ color: "#333" }}>Checklist Categories</Typography>

            <TableContainer
              sx={{ border: "1px solid #ccc", borderRadius: "8px" }}
            >
              <Table aria-label="Checklist Categories Table">
                <TableHead sx={{ backgroundColor: "#f1f1f1" }}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold", padding: "12px" }}>
                      Category
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", padding: "12px" }}>
                      Category Rating
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {validItems?.length > 0 &&
                  prioritizationCheckList?.data
                    ?.listInitiativeChecklistCategoryEntity?.length > 0 ? (
                    prioritizationCheckList.data.listInitiativeChecklistCategoryEntity.map(
                      (item, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 0 ? "#f9f9f9" : "transparent",
                          }}
                        >
                          <TableCell sx={{ padding: "12px" }}>
                            {item.description}
                          </TableCell>
                          <TableCell sx={{ padding: "12px" }}>
                            {renderPercentageBar(item.weightage.toFixed(2))}
                          </TableCell>
                        </TableRow>
                      )
                    )
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan="2"
                        sx={{ textAlign: "center", padding: "12px" }}
                      >
                        No Checklist Categories Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
        {/* Added CheckListResponseId as UniqueID, checkListID and stageID as priorChecklistID by Gauri on 08 Feb 2025 */}
        <InitiativeDetails
          checkListID={checkListID}
          checkListID1={checkListID1}
          initiativeData1={selectedCheckList}
          ideaID1={ideaID1}
          UniqueID={selectedCheckListResponseId}
          priorChecklistID={priorChecklistID}
          setRefresh1={setRefresh1}
          refresh={refresh}
          stageID={stageID}
          // prioritizationCheckList={prioritizationCheckList}
          selectedRespondedBY={selectedRespondedBY}
          selectedStageName={selectedStageName}
          stageDetails={stageDetails} // Added by Gauri to get current stage details on 08 Apr 2025
        />
      </div>
    </Drawer>
  );
};

export default PrioritizationCheckList;
